export default [
    {
        path: '/login',
        name: 'LOGIN'
    },
    {
        path: '/signup',
        name: 'SIGNUP'
    },
]